import usePublicSearchContext from '@/publicSearch/store/usePublicSearchContext';

/**
 * True when the current society exposes EBV on the public site.
 * Defaults to true while society is loading so we do not flash-hide EBV UI.
 */
export function useIsEbvEnabled(): boolean {
  const society = usePublicSearchContext((c) => c.society);
  return society?.isEbvEnabled ?? true;
}
